import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, mergeMap, pluck, tap } from 'rxjs/operators';
import { EntityTypes } from 'src/app/common-models/node-types/node-types';
import { Detail } from 'src/app/project-management/common/navigation-tabs/detail/detail.model';
import { AppState } from 'src/app/root-store/app-state';
import * as routerSelectors from 'src/app/root-store/root-store.selector';
import { SharedPackageService } from '../../node-header/shared.service';

@Component({
  selector: 'app-package-detail-view',
  templateUrl: './package-detail-view.component.html',
  styleUrls: ['./package-detail-view.component.scss'],
})
export class PackageDetailViewComponent implements OnInit {
  detailData$: Observable<Detail>;
  nodeId$: Observable<number>;
  nodeType$: Observable<EntityTypes>;
  loading: boolean;

  constructor(
    private store$: Store<AppState>,
    private shareService: SharedPackageService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.nodeId$ = this.store$.select(routerSelectors.getIdSelector);

    this.detailData$ = this.store$.select(routerSelectors.getShareIdSelector).pipe(
      filter((x) => !!x && x.hasState),
      map((x) => x.id),
      tap(() => (this.loading = true)),
      mergeMap((id) => this.shareService.getViewPackageDetails(id)),
      mergeMap((details) =>
        this.route.data.pipe(
          pluck('type'),
          map((type) => ({ ...details, type })),
        ),
      ),
      tap(() => (this.loading = false)),
    );

    this.nodeType$ = this.route.data.pipe(pluck('type'));
  }
}
